import { Card, Grid, Icon, Tab, Tabs } from '@mui/material'
import DashboardLayout from 'components/LayoutContainers/DashboardLayout'
import DashboardNavbar from 'components/Navbars/DashboardNavbar'
import SoftBox from 'components/SoftBox'
import SoftTypography from 'components/SoftTypography'
import { useState } from 'react'
import { getUproColor } from 'utils/colors'
import { ReportesFinancierosContext } from './context'

import ReporteFinanciero from './components/ReporteFinanciero'
import ReporteConsumo from './components/ReporteConsumo'
import ReporteCuentasxCobrar from './components/ReporteCuentasxCobrar'

function ReportesFinancieros() {
    const [activeTab, setActiveTab] = useState(0);
    const TabComponents = [
        <ReporteFinanciero key="reporte-financiero" />,
        <ReporteConsumo key="reporte-consumo" />,
        <ReporteCuentasxCobrar key="reporte-cuentasxcobrar" />,
    ];
    const [data, setData] = useState({});

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <SoftBox py={3}>
                <SoftBox mb={3}>
                    <Card>
                        <Grid container spacing={2} p={3}>
                            <Grid item xs={12}>
                                <SoftBox
                                    display={{
                                        xs: "flex-row",
                                        sm: "flex",
                                    }}
                                    justifyContent="space-between"
                                    alignItems="center"
                                >
                                    <SoftBox display="flex" justifyContent="space-between" alignItems="center">
                                        <SoftTypography variant="h6">Reportes Financieros</SoftTypography>
                                    </SoftBox>
                                </SoftBox>
                            </Grid>
                        </Grid>
                        <SoftBox p={2}>
                            <Tabs value={activeTab} onChange={(e, value) => setActiveTab(value)}>
                                <Tab
                                    label={
                                        <SoftBox
                                            display="flex"
                                            alignItems="center"
                                            gap={0.5}
                                            justifyContent="center"
                                        >
                                            <Icon fontSize="small" sx={{ color: getUproColor("uproYellow") }}>
                                                text_snippet
                                            </Icon>
                                            Reporte Financiero
                                        </SoftBox>
                                    }
                                />
                                <Tab
                                    label={
                                        <SoftBox
                                            display="flex"
                                            alignItems="center"
                                            gap={0.5}
                                            justifyContent="center"
                                        >
                                            <Icon fontSize="small" sx={{ color: getUproColor("uproYellow") }}>
                                                category
                                            </Icon>
                                            Reporte de Consumo
                                        </SoftBox>
                                    }
                                />
                                <Tab
                                    label={
                                        <SoftBox
                                            display="flex"
                                            alignItems="center"
                                            gap={0.5}
                                            justifyContent="center"
                                        >
                                            <Icon fontSize="small" sx={{ color: getUproColor("uproYellow") }}>
                                                route
                                            </Icon>
                                            Reporte de Cuentas por Cobrar
                                        </SoftBox>
                                    }
                                />
                            </Tabs>
                        </SoftBox>
                        <div
                            style={{
                                transition: "height 0.3s ease",
                                overflow: "hidden",
                                overflowY: "auto",
                            }}
                        >
                            <SoftBox sx={{ overflowY: "auto" }}>
                                <ReportesFinancierosContext.Provider
                                    value={{
                                        data,
                                        setData,
                                    }}
                                >
                                    {TabComponents[activeTab]}
                                </ReportesFinancierosContext.Provider>
                            </SoftBox>
                        </div>
                    </Card>
                </SoftBox>
            </SoftBox>
        </DashboardLayout>
    )
}

export default ReportesFinancieros
